import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MapPickerService {

  getAddress: Subject<any>= new Subject();
  constructor() { }
}
